<template>
  <div class="loginMode" :style="{ margin: margin, fontSize: fontSize + 'px' }">
    <div class="loginMode_box">
      <div v-if="loginType == 0" @click.stop="$emit('exchange', 1)">密码登录</div>
      <div v-if="loginType == 1" @click.stop="$emit('exchange', 0)">验证码登录</div>
    </div>
    <div class="interval" v-if="loginType == 1 && !quick"></div>
    <template v-if="quick">
      <div class="interval"></div>
      <div @click="$emit('local', 1)">一键登录</div>
      <div class="interval" v-if="loginType == 1"></div>
    </template>
    <div class="register-btn" v-if="loginType == 1" @click.stop="$emit('exchange', 2)">
      账号注册
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginMode',
  props: {
    quick: {
      type: Boolean,
      default: false
    },
    loginType: {
      type: Number,
      default: 0
    },
    stateCode: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      margin: '2rem 0 14.8rem 0', // 80rpx 0 592rpx 0
      fontSize: 14 // 28rpx
    }
  },
  watch: {
    loginType: {
      handler(val) {
        switch (val) {
          case 0:
            this.margin = '2rem 0 10rem 0' // 80rpx 0 400rpx 0
            break
          case 1:
            this.margin = '2rem 0 7rem 0' // 80rpx 0 280rpx 0
            break
          default:
            break
        }
      },
      immediate: true
    },
    stateCode: {
      handler(val) {
        switch (val) {
          case -2:
            this.info.password = ''
            this.info.confirm_password = ''
            break
          case -1:
            this.info.username = ''
            break
          case 0:
            this.info = {
              username: '',
              password: '',
              confirm_password: ''
            }
            break
          default:
            break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loginMode {
  width: 15rem; // 600rpx
  margin: 0 auto;
  box-sizing: border-box;
  font-size: 0.7rem; // 28rpx
  color: #855200;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .loginMode_box {
    display: flex;
    align-items: center;
    font-size: 0.7rem; // 28rpx
  }

  .interval {
    margin: 0 0.95rem; // 38rpx
    width: 0.05rem; // 2rpx
    height: 0.6rem; // 24rpx
    background: #CACACA;
  }

  .register-btn {
    font-size: 0.7rem; // 28rpx
  }
}
</style>